import {
  Button,
  IconValidationValid,
  Stack,
  Text,
} from '@adc/parallax-component-library';
import { IconPrint } from '@adc/parallax-icons';
import { Dialog } from '@tamagui/dialog';
import { Image } from '@tamagui/image';

import QrWikipedia from '~/assets/qr-wikipedia.png';
import { useModal } from '~/features/modals/useModal';
import { buildTestId } from '~/utils/buildTestId';

import { ModalOverlay } from '../ModalOverlay';

type PatientAddedModalProps = {
  testID: string;
  patientId: string;
  patientName: string;
  inviteBy: 'none' | 'email';
  patientEmail?: string;
  patientPhone?: string;
};

export const PatientAddedModal = ({
  testID,
  patientId,
  patientName,
  inviteBy,
  patientEmail,
}: PatientAddedModalProps) => {
  const { closeModal } = useModal();

  const onClose = () => {
    closeModal('PatientAdded');
  };

  const handleViewPatientProfile = () => {
    console.warn('TODO: navigate to created patient profile', { patientId });
  };
  const handlePrintQR = () => {
    console.log('TODO: print QR code for patient profile', { patientId });
  };
  const onOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog open onOpenChange={onOpenChange} modal>
      <Dialog.Portal>
        <ModalOverlay />

        <Dialog.Content
          testID={testID}
          key="content"
          elevate
          animateOnly={['transform', 'opacity']}
          animation={[
            'quick',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ]}
          enterStyle={{ x: 0, y: 20, opacity: 0 }}
          exitStyle={{ x: 0, y: 10, opacity: 0, scale: 0.95 }}
          padding="$6"
          paddingBottom="$12"
          borderWidth="$0"
          maxWidth={800}
          width="100%"
          borderRadius="$1.5"
          backgroundColor="$surface.background"
          alignItems="center"
        >
          <IconValidationValid size="L" color="$support.positive.default" />
          <Text
            type="$h3.strong"
            testID={buildTestId({
              testID,
              suffix: 'title',
            })}
          >
            Patient Added
          </Text>

          <Text type="$bodySmall.default" color="$text.60" paddingTop="$3">
            A new patient profile for {patientName} has been created.
          </Text>

          <Text
            type="$bodySmall.default"
            color="$text.60"
            testID={buildTestId({
              testID,
              suffix: ['invite', 'message', inviteBy],
            })}
          >
            An invitation has been sent to {patientEmail}.
          </Text>

          <Text type="$bodySmall.default" color="$text.60" paddingTop="$4">
            The patient can also scan the QR code below to download the app.
          </Text>

          <Image
            source={{
              width: 156,
              height: 156,
              uri: QrWikipedia,
            }}
            width={156}
            height={156}
            marginTop="$4"
            testID={buildTestId({ testID, suffix: ['qr', 'code'] })}
          />

          <Text type="$bodySmall.default" color="$text.60" marginTop={-8}>
            [www.url...]
          </Text>
          <Stack gap="$2" marginTop="$6">
            <Button
              variant="secondary"
              label="View Patient Profile"
              onPress={handleViewPatientProfile}
              // @ts-expect-error Parallax doesn't type this prop
              minWidth={256}
              testID={buildTestId({
                testID,
                suffix: ['button', 'patient', 'profile'],
              })}
            />
            <Button
              variant="secondary"
              label="Print"
              iconStart={<IconPrint />}
              onPress={handlePrintQR}
              // @ts-expect-error Parallax doesn't type this prop
              minWidth={256}
              testID={buildTestId({
                testID,
                suffix: ['button', 'print', 'patient', 'profile'],
              })}
            />
            <Button
              variant="primary"
              label="Done"
              onPress={onClose}
              // @ts-expect-error Parallax doesn't type this prop
              minWidth={256}
              testID={buildTestId({
                testID,
                suffix: ['button', 'done'],
              })}
            />
          </Stack>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
};
